import { DownloadIcon } from 'lucide-react'

export default function DownloadDebitList() {
  const handleDownload8821 = () => {
    const link = document.createElement('a')
    link.href = '/files/debit_list.xlsx'
    link.download = 'debit_list.xlsx'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <div className='w-full mx-auto p-6 bg-white rounded-lg shadow-lg'>
      <div>
        <h2 className='text-2xl font-semibold mb-4 text-center text-gray-800'>Debit List</h2>
        <p className='text-center'>Make sure to download, fill out, and upload the debit list</p>
        <button
          onClick={handleDownload8821}
          className='w-full flex items-center justify-center gap-2 rounded-md px-4 py-3 text-white mt-6 transition bg-ertc-primary hover:bg-ertc-primary-dark'
        >
          <DownloadIcon size={20} />
          Download Debit List
        </button>
      </div>
    </div>
  )
}